import React from 'react'
import { Button, ButtonProps } from '@chakra-ui/react'

interface Props {
  number: number
  isCurrent?: boolean
  onChangePage: (page: number) => void
  lisPaginationItemProps?: ButtonProps
}

export function ListPaginationItem({
  number,
  isCurrent = false,
  lisPaginationItemProps,
  onChangePage,
}: Props) {
  if (isCurrent) {
    return (
      <Button
        {...lisPaginationItemProps}
        w="4"
        size="sm"
        fontSize="xs"
        disabled
        colorScheme="brand"
        _disabled={{
          bg: 'brand.500',
          cursor: 'default',
        }}
      >
        {number}
      </Button>
    )
  }

  return (
    <Button
      w="4"
      size="sm"
      fontSize="xs"
      colorScheme="whiteAlpha"
      onClick={() => onChangePage(number)}
    >
      {number}
    </Button>
  )
}
